<div class="dialog-content">
    <h3 class="dialog-title">
        <img
            class="dialog-icon"
            [class.dialog-icon--success]="data.type === 'success'"
            [class.dialog-icon--error]="data.type !== 'success'"
            [src]="data.type === 'success' ? iconPaths.CHECK_CIRCLE : iconPaths.ALERT_CIRCLE"
            [alt]="data.type === 'success' ? 'Success' : 'Warning'"
            width="24"
            height="24"
        />
        {{ data.title }}
    </h3>
    <div class="dialog-title-separator"></div>
    <div class="dialog-body">
        <p class="dialog-message">
            {{ data.message }}
        </p>

        @if (data.collectRemark) {
            <div class="dialog-remark">
                @if (data.useNotesTextareaForRemark) {
                    <app-notes-textarea-field
                        class="dialog-remark__notes-field"
                        name="confirmationDialogRemark"
                        [(ngModel)]="remarkText"
                        [ngModelOptions]="{ standalone: true }"
                        [label]="data.remarkLabel || 'Remark'"
                        [placeholder]="data.remarkPlaceholder || 'Enter remark'"
                        [rows]="4"
                        [maxLength]="data.remarkMaxLength ?? 500"
                        [showCounter]="true"
                        [minLengthWarning]="notesRemarkMinLength()"
                        [errorMessage]="remarkNotesErrorMessage()"
                        [fieldClass]="'dialog-remark__notes-form-field'"
                        (valueChanged)="handleRemarkInteraction($event)"
                        (blurred)="handleRemarkInteraction()"
                    />
                } @else {
                    <z-form-field class="dialog-remark__form-field">
                        <label z-form-label>{{ data.remarkLabel || 'Remark' }}</label>
                        <z-form-control>
                            <textarea
                                z-input
                                [(ngModel)]="remarkText"
                                [placeholder]="data.remarkPlaceholder || 'Enter remark'"
                                rows="4"
                                [required]="data.remarkRequired || false"
                            ></textarea>
                        </z-form-control>
                    </z-form-field>
                }
            </div>
        }
    </div>

    <div class="dialog-actions">
        @if (data.cancelText) {
            <button
                [class]="
                    'dialog-button dialog-button--' + (data.cancelButtonVariant || 'secondary')
                "
                (click)="handleCancelClick()"
            >
                {{ data.cancelText || defaultTexts.CONFIRMATION.cancelText }}
            </button>
        }
        <button
            [class]="'dialog-button dialog-button--' + (data.confirmButtonVariant || 'primary')"
            (click)="handleConfirmClick()"
            [disabled]="isConfirmDisabled()"
        >
            {{ data.confirmText || defaultTexts.CONFIRMATION.confirmText }}
        </button>
    </div>
</div>
